export enum OrganisationStatus {
  Pending,
  Active,
  Inactive,
  NotSuitable,
}
